import React, { useRef, useState } from "react";
import SwiperCore, { Autoplay, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import HomeData from "../../data/impact.json";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const ReportsHistoryContainer = ({ contRef }) => {
    const swiperRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);
    const [currentReport, setCurrentReport] = useState(
        HomeData[5]?.reports?.[0]?.name || ""
    );

    SwiperCore.use([Autoplay, Navigation]);
    const swiperOption = {
        loop: true,
        rewind: "true",
        // navigation: true,
        navigation: {
            prevEl: ".reports-swiper-prev",
            nextEl: ".reports-swiper-next",
        },
        speed: 2000,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: false,
        autoplay: {
            delay: 2000,
            disableOnInteraction: true,
        },
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 1,
            },
            // when window width is >= 640px
            640: {
                slidesPerView: 2,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 2,
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 3,
            },
        },
    };

    const toggleAutoplay = () => {
        if (!swiperRef.current) return;

        if (isPlaying) {
            swiperRef.current.autoplay.stop();
        } else {
            swiperRef.current.autoplay.start();
        }
        setIsPlaying(!isPlaying);
    };

    return (
        <div className="brand-section mb-10 pt-5" ref={contRef}>
            <div className="container">
                <div className="row mb-5 ">
                    <div className="col-xl-12 col-lg-12 mx-auto text-center">
                        <div className="title-section title-section text-center mb-5">
                            <span className="sub-title"></span>
                            <h2
                                className="date-meta g-color"
                                style={{
                                    fontFamily: "Open Sans, sans-serif",
                                    fontWeight: "bolder",
                                }}
                            >
                                Download Reports
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-12" role="region" aria-label="Carousel">
                        <div
                            role="status"
                            aria-live="polite"
                            className="visually-hidden"
                        >
                            Currently showing: {currentReport}
                        </div>
                        <Swiper
                            className="brand-carousel"
                            {...swiperOption}
                            onSwiper={(swiper) => (swiperRef.current = swiper)}
                            onSlideChange={(swiper) => {
                                const report =
                                    HomeData[5]?.reports?.[swiper.realIndex];

                                if (report) {
                                    setCurrentReport(report.name);
                                }
                            }}
                        >
                            {HomeData[5].reports &&
                                HomeData[5].reports.map((single, key) => {
                                    return (
                                        <SwiperSlide key={key}>
                                            <div className="col-9">
                                                <Link
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    to={
                                                        process.env.PUBLIC_URL +
                                                        single.link
                                                    }
                                                >
                                                    <div className="bg-primary report-box text-center">
                                                        <i className=" fa fa-download fa-lg y-color"></i>
                                                        <div className=" report-inner-box text-center mt-2">
                                                            <p className=" ">
                                                                <b>
                                                                    {
                                                                        single.name
                                                                    }
                                                                </b>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}

                            <div
                                className="reports-swiper-prev"
                                aria-hidden="false"
                            >
                                <button
                                    aria-label="Previous report"
                                    className="swiper-nav-btn btn-primary-outline"
                                    style={{ marginLeft: 15 }}
                                    onClick={() =>
                                        swiperRef.current?.slidePrev()
                                    }
                                >
                                    <i
                                        className="fa fa-angle-left fs-1"
                                        style={{
                                            color: "#1f7a2e",
                                            fontWeight: "bold",
                                        }}
                                    ></i>
                                </button>
                            </div>

                            <div
                                className="reports-swiper-next"
                                aria-hidden="false"
                            >
                                <button
                                    aria-label="Next report"
                                    className="swiper-nav-btn btn-primary-outline"
                                    style={{ marginRight: 15 }}
                                    onClick={() =>
                                        swiperRef.current?.slideNext()
                                    }
                                >
                                    <i
                                        className="fa fa-angle-right fs-1"
                                        style={{
                                            color: "#1f7a2e",
                                            fontWeight: "bold",
                                        }}
                                    ></i>
                                </button>
                            </div>
                        </Swiper>
                        {/* <div
                            className="d-flex justify-content-center gap-3 mt-4"
                            aria-label="Carousel navigation"
                        >
                            <button
                                className="btn-primary btn-hover-primary reports-swiper-prev btn btn-outline-primary"
                                aria-label="Previous report"
                                onClick={() => swiperRef.current?.slidePrev()}
                            >
                                Previous
                            </button>

                            <button
                                className="btn-primary btn-hover-primary reports-swiper-next btn "
                                aria-label="Next report"
                                onClick={() => swiperRef.current?.slideNext()}
                            >
                                Next
                            </button>
                        </div> */}

                        <div className="d-flex justify-content-center mt-10">
                            <button
                                onClick={toggleAutoplay}
                                aria-label={
                                    isPlaying
                                        ? "Pause news slider"
                                        : "Play news slider"
                                }
                                title={isPlaying ? "Pause" : "Play"}
                                className="btn-primary btn-hover-primary d-flex justify-content-center align-items-center"
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "50%",
                                    border: "none",
                                }}
                            >
                                <i
                                    className={
                                        isPlaying ? "fa fa-pause" : "fa fa-play"
                                    }
                                    aria-hidden="true"
                                ></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ReportsHistoryContainer.propTypes = {
    contRef: PropTypes.any,
};

export default ReportsHistoryContainer;
